<template>
    <div class="tracking">

    </div>
</template>

<script>


    export default {

        props: ["model", "schema", "checkout"],

        data: function () {
            return {
                test: true,
            }
        },

        mounted() {


        },

        created() {

            Event.$on("checkout_ready", function () {
                this.FBInitiateCheckout();

            }.bind(this));


            Event.$on("cart_add_to_cart", function (product) {
                // console.warn("PRODUCT");
                // console.warn(product);
                this.UAAddToCart(product);
                this.FBAddToCart(product);
            }.bind(this));


        },

        methods: {
//
            init: function () {

                let selectedProductOrWaitlist = (this.model.products[0]) ? this.model.products[0] : this.model.waitlists[0];
               // console.warn("selectedProductOrWaitlist");
               // console.warn(selectedProductOrWaitlist);

                window.addEventListener("load", function (event) {
                    Event.$emit("checkout_ready");
                    Event.$emit("cart_add_to_cart", selectedProductOrWaitlist);
                });

            },

//            eventAddToCart: function (product) {
//                console.log("product:");
//                console.log(product.id);
//                console.log(product.name);
//                console.log(product.price_total);
//                console.log(product.checkout_id);
//            }

            UAAddToCart: function (product) {
                dataLayer.push({
                    'event': 'addToCart',
                    'ecommerce': {
                        'currencyCode': 'EUR',
                        'add': {                                // 'add' actionFieldObject measures.
                            'products': [{                        //  adding a product to a shopping cart.
                                'name': product.name,
                                'id': product.id,
                                'price': product.price,
                                'category': this.checkout.name,
                                'quantity': 1
                            }]
                        }
                    }
                });
            },

            FBInitiateCheckout: function () {
                this.FBTriggerPixel('InitiateCheckout');
            },

            FBAddToCart: function (product) {
                this.FBTriggerPixel ('AddToCart', {
                    content_name: product.name,
                    content_category: this.checkout_name,
                    content_ids: [product.id],
                    content_type: 'product',
                    value: product.price,
                    currency: "EUR"
                });
            },

            FBTriggerPixel(event, data = undefined, i = 0) {
                if(typeof fbq !== 'undefined'){
                    fbq('track', event, data);
                } else {
                    if(i < 10) {
                        setTimeout(function () {
                            this.FBTriggerPixel (event, data, i+1);
                        }, 1000)
                    }
                }

            }
        },


    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/Tracking.vue